<template>
  <drop-down :class="`options ${position}-position`">
    <template #title>
      <md-button class="md-icon-button" data-toggle="dropdown">
        <md-icon>settings</md-icon>
      </md-button>
    </template>
    <template #default>
      <ul :class="`dropdown-menu dropdown-menu-${position} dropdown-menu`">
        <slot />
      </ul>
    </template>
  </drop-down>
</template>

<script>
export default {
  name: "OptionsButton",
  props: {
    position: {
      type: String,
      default: () => "right",
      validator(value) {
        return ["left", "right"].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.options {
  position: absolute;
  top: 0;
  z-index: 1;

  &.right-position {
    right: 30px;
  }

  &.left-position {
    left: 30px;
  }

  .md-icon-button {
    padding: 10px;
  }

  .dropdown-menu li {
    cursor: pointer;

    a {
      display: inline-block;
      width: 100%;
    }
  }
}
</style>
